import {Callback, Mix} from "../Core/Reflection";
import {TransformBackup} from "../Core/TransformBackup";
import {Application} from "../Application";
import {Ease} from "../Core/Animatable";
import {Sprite} from "../Core/Sprite";
import {Container} from "../Core/Container";
import * as PIXI from "pixi.js";
import {LunaCharacter} from "./LunaCharacter";

export class LunaPrompter extends Mix(Container, TransformBackup) {

    readonly sprite = this.addChild(new Sprite());
    readonly character = new LunaCharacter();

    constructor() {
        super();
        this.visible = false;
    }

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        this.sprite.setLayoutTexture(texture, anchorX, anchorY);
    }

    onLayout() {
        this.saveTransform();
        this.y = Application.instance.size.y + this.height;
        this.addChild(this.character);
        this.character.scale.set(0.35);
        this.character.x = this.sprite.width * 0.05;
        this.character.y = -this.sprite.height * 0.08;
        this.character.characterSpine.autoUpdate = false;
    }

    show(cb?: Callback) {
        this.killTweens();
        this.visible = true;
        this.character.characterSpine.autoUpdate = true;
        this.moveYTo(this.getTransformBackup().y, 0.4, Ease.backOut, cb);
    }

    hide(cb?: Callback) {
        this.killTweens();
        this.moveYTo<LunaPrompter>(Application.instance.size.y + this.height, 0.2, Ease.sineIn, {
            delay: 0.6,
            onComplete: () => {
                this.visible = false;
                this.character.characterSpine.autoUpdate = false;
                if (cb) cb();
            }
        });
    }
}